import { Box, Skeleton } from '@mui/material'
import HiddenDesktop from '../../styles/HiddenDesktop'
import HiddenMobile from '../../styles/HiddenMobile'

function HomeSliderSkeleton() {
  return (
    <>
      {/* Bradcrumb  */}
      <HiddenDesktop>
        <Box height={50} />
      </HiddenDesktop>
      <HiddenMobile>
        <Skeleton variant="rectangular" animation="wave" height="27.5rem" width="100%" style={{ maxWidth: '1920px' }} />
      </HiddenMobile>
      <HiddenDesktop>
        <Box p={2}>
          <Skeleton variant="rectangular" animation="wave" height="144px" width="100%" sx={{ borderRadius: 8 }} />
        </Box>
      </HiddenDesktop>
    </>
  )
}

export default HomeSliderSkeleton
